import development from '@/data/environment/development'
import productivo from '@/data/environment/productivo'
import staging from '@/data/environment/staging'
import lab from '@/data/environment/lab'

let config = development

if (process.env.NODE_ENV === 'production') {
  config = productivo
}
if (process.env.NODE_ENV === 'staging') {
  config = staging
}

if (process.env.NODE_ENV === 'lab') {
  config = lab
}
export const environment = config
